
import Vue from 'vue';
import HeaderCustomerMenu from '@root/common/components/layout/header/HeaderCustomerMenu.vue';
import Dropdown from '@core/components/UI/dropdown/Dropdown.vue';

interface Data {
  forceClose: {
    value: boolean;
    timestamp: string;
  };
}

interface Props {
  data: {
    isLoggedIn: boolean;
    profile: {
      displayName: string | null;
      id: number;
      email: string;
      firstName: string | null;
      lastName: string | null;
    };
  };
  openLoginModal: () => void;
  logout: () => void;
}

interface Methods {
  linkClicked: () => void;
}

interface Computed {
  isFirstNameFilled: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    HeaderCustomerMenu,
    Dropdown,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    openLoginModal: {
      type: Function,
      required: true,
    },
    logout: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      forceClose: {
        value: false,
        timestamp: '',
      },
    };
  },
  computed: {
    isFirstNameFilled() {
      return this.$store.state.customer.profile?.firstName || false;
    },
  },
  methods: {
    linkClicked() {
      this.forceClose = {
        value: true,
        timestamp: String(new Date().getTime()),
      };
    },
  },
});
